// extracted by mini-css-extract-plugin
export default {"SecondaryButton":"PerinHealthModel_SecondaryButton__jdo2l","ModelButton":"PerinHealthModel_ModelButton__aN0ds"};